export const SampleLesson= [
    {
        id: 1,
        lesson_title:"On-boarding",
        progress:20,
        content:"ZhULGD",
        description:"Lorem ipsum dolor sit amet consectetur. Est morbi tortor egestas scelerisque. Tellus fermentum nisi consequat sed tellus mauris pharetra. Feugiat sed vel tristique ultrices varius aliquam. Gravida mauris tincidunt proin in sit ut."

    },
    {
        id: 2,
        lesson_title:"Eddify",
        progress:30,
        content:"LGD5hNQs",
        description:"aa"


    },
    {
        id: 3,
        lesson_title:"On-boarding",
        progress:20,
        content:"sssssss",
        description:"aa"


    },
    {
        id: 4,
        lesson_title:"Eddify",
        progress:30,
        content:"Zssddddaas",
        description:"aa"



    }
]
